$(document).on("click", ".content-drawer__stages-wrapper .accordion__link", function() {
    $(this).closest(".content-drawer__stages-item").toggleClass("opened");
});